// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tip-toggle__button{display:flex;align-items:center;cursor:pointer}.tip-toggle__button__text{color:#443fdb;font-weight:500}.tip-toggle__content{padding-top:.8rem;padding-bottom:.4rem}", ""]);
// Exports
module.exports = exports;
